import { motion } from "framer-motion";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";

const partners = [
  { name: "Jobindex", logo: "https://izkyvqbleuatzitwmtjw.supabase.co/storage/v1/object/public/pics2/Jobindex_logo.png" },
  { name: "LocalAway", logo: "https://izkyvqbleuatzitwmtjw.supabase.co/storage/v1/object/public/pics2/localaway-logo.png" },
  { name: "Højskolerne", logo: "https://izkyvqbleuatzitwmtjw.supabase.co/storage/v1/object/public/pics2/hoejskolerne-logo.png" },
];

const PartnersSection = () => {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section className="py-16 md:py-20 bg-background" ref={ref}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center mb-10"
        >
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
            Udvalgte samarbejder
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={isVisible ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex items-center justify-center gap-12 md:gap-20 flex-wrap"
        >
          {partners.map((partner) => (
            <div key={partner.name} className="flex items-center justify-center h-12 opacity-50 hover:opacity-80 transition-opacity">
              <img
                src={partner.logo}
                alt={partner.name}
                className="h-8 md:h-10 w-auto object-contain grayscale"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default PartnersSection;
